import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../@types';
import highlighter from "../../assets/images/Icon/highlightericon.svg";
import info from "../../assets/images/Icon/info.svg";
import { useColorMode } from 'theme-ui';
export const HighlighterPopup: React.FC = ({ }) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef<HTMLDivElement>(null);
    const { highlighters } = useSelector((state: RootState) => state.project);
    // console.log("highlighters---", highlighters);
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#8d8d8d" : "#dadada";
    const highlighterPopup = colorMode === 'light' ? "#fff" : "#20283c";

    const togglePopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
            setIsPopoverOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div ref={popoverRef} className='d-flex align-items-center gap-2 position-relative ' onClick={togglePopover} style={{ cursor: "pointer" }}>
                <img src={highlighter} />
                <p className='mb-0 high ' style={{ cursor: 'pointer', color: titleHeader }}>&nbsp;&nbsp;Highlighters&nbsp;&nbsp;</p>
                <img src={info} />
                {isPopoverOpen && (
                    <div className="highlighter-popup" style={{ backgroundColor: highlighterPopup }}>
                        {highlighters?.map((highlight, index) => {
                            return (
                                <>
                                    <p style={{ color: highlight?.color }}><img src={highlight?.icon} alt='highlight' /> &nbsp;{highlight?.name}</p>
                                </>
                            )
                        })}
                    </div>
                )}
            </div>

        </>
    );
};
